import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import axios from "axios";
import { BasedURL } from "../util/constants";
import NavBar from "./NavBar";
import Footer from "./Footer";

export default function NewsDetail() {
  const { id } = useParams();
  const history = useHistory();
  const [item, setItem] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    axios
      .get(`${BasedURL}/news/${id}`)
      .then((r) => {
        if (!r.data) { setNotFound(true); return; }
        setItem(r.data);
      })
      .catch(() => setNotFound(true))
      .finally(() => setLoading(false));
  }, [id]);

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <NavBar />

      <main className="flex-1 max-w-3xl mx-auto w-full px-4 py-12">
        {loading && (
          <p className="text-gray-400 text-sm">Loading…</p>
        )}

        {notFound && !loading && (
          <div className="text-center py-20">
            <p className="text-gray-500 text-lg mb-6">Article not found.</p>
            <button
              onClick={() => history.push("/")}
              className="text-green-700 font-semibold underline"
            >
              Back to home
            </button>
          </div>
        )}

        {item && (
          <>
            {/* Back */}
            <button
              onClick={() => history.goBack()}
              className="text-sm text-gray-500 hover:text-gray-800 mb-8 flex items-center gap-1 bg-transparent border-0 cursor-pointer p-0"
            >
              ← Back
            </button>

            {/* Category badge */}
            {item.category && (
              <span
                className="inline-block text-white text-xs font-bold px-3 py-1 rounded-full mb-4"
                style={{ background: "#f59e0b" }}
              >
                {item.category.toUpperCase()}
              </span>
            )}

            {/* Title */}
            <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3 leading-snug">
              {item.title}
            </h1>

            {/* Date */}
            {item.publishedAt && (
              <p className="text-sm text-gray-400 mb-6">{item.publishedAt}</p>
            )}

            {/* Hero image */}
            {item.imageUrl && (
              <img
                src={item.imageUrl}
                alt={item.title}
                className="w-full rounded-xl object-cover mb-8"
                style={{ maxHeight: 400 }}
              />
            )}

            {/* Description */}
            {item.description && (
              <p className="text-gray-600 text-base leading-relaxed mb-6 font-medium">
                {item.description}
              </p>
            )}

            {/* Full content */}
            {item.content && item.content !== "Full article content here." && (
              <div
                className="text-gray-700 text-base leading-relaxed prose max-w-none"
                dangerouslySetInnerHTML={{ __html: item.content }}
              />
            )}
          </>
        )}
      </main>

      <Footer />
    </div>
  );
}
